var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.computedLink}},[_c('code',[_vm._v(_vm._s(_vm.component))])])
}
var staticRenderFns = []

export { render, staticRenderFns }